import getFireRiskInfo from "../../../../utils/getFireRiskInfo";
import moment from 'moment';

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.borderRadius = '3px';
    tooltipEl.style.color = 'white';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'auto';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';
    tooltipEl.style.cursor = 'pointer';
    tooltipEl.setAttribute('id', 'chartTooltip');

    const table = document.createElement('table');
    table.style.margin = '0px';
    table.style.whiteSpace = 'nowrap';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  } else {
    tooltipEl.setAttribute('data-date-info', tooltip.dataPoints[0].label)
    const cellValue = tooltip.dataPoints[0].raw;
    tooltipEl.style.background = getFireRiskInfo(cellValue).riskGaugeColor;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines);

    const tableHead = document.createElement('thead');

    titleLines.forEach(title => {
      const tr = document.createElement('tr');
      tr.style.borderWidth = 0;

      const th = document.createElement('th');
      th.style.fontSize = '14px';
      th.style.fontWeight = 'normal'
      th.style.font = 'Poppins'
      th.style.borderWidth = 0;
      const text = document.createTextNode(moment(title).format('MM-DD-YYYY'));
      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement('tbody');
    bodyLines.forEach((body) => {
      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = 0;

      const td = document.createElement('td');
      td.style.borderWidth = 0;

      const text = document.createTextNode(body);

      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  if (positionX + tooltip.caretX >= window.screen.width) {
    tooltipEl.style.left = positionX + tooltip.caretX - 45 + 'px';
  } else {
    tooltipEl.style.left = positionX + tooltip.caretX - 20 + 'px';
  }
  tooltipEl.style.top = positionY + tooltip.caretY - 70 + 'px';
  tooltipEl.style.font = 'Poppins';
  tooltipEl.style.fontSize = '14px';
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};